<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" type="text" placeholder="Username" />
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" type="text" placeholder="Name" />
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
